import React from 'react';
import { FadeIn } from './FadeIn';
import { CountUp } from './CountUp';
export function StatsSection() {
  const stats = [{
    number: 90,
    suffix: '',
    title: 'Días',
    desc: 'para transformar la salud'
  }, {
    number: 70,
    suffix: '%',
    title: 'del sistema inmune',
    desc: 'vive en el intestino'
  }, {
    number: 30,
    suffix: '',
    title: 'plantas por semana',
    desc: '= microbiota de élite'
  }, {
    number: 15,
    suffix: '',
    title: 'recetas médicas',
    desc: 'comestibles'
  }];
  return <section className="py-16 md:py-24 px-4 bg-green-deep text-white" data-id="element-437">
      <div className="max-w-5xl mx-auto" data-id="element-438">
        <FadeIn data-id="element-439">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-center mb-12 text-green-mint" data-id="element-440">
            LOS NÚMEROS QUE IMPORTAN
          </h2>
        </FadeIn>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-441">
          {stats.map((stat, index) => <FadeIn key={index} delay={index * 0.1} className="text-center" data-id="element-442">
              <div className="font-heading font-bold text-5xl md:text-6xl text-white mb-2" data-id="element-443">
                <CountUp end={stat.number} suffix={stat.suffix} data-id="element-444" />
              </div>
              <div className="font-bold text-green-lime text-sm md:text-base mb-1 uppercase tracking-wider" data-id="element-445">
                {stat.title}
              </div>
              <div className="text-green-mint/80 text-xs md:text-sm" data-id="element-446">
                {stat.desc}
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}